<template>
  <div id="config">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Công nợ', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bconfig" class="soft-control">
        <b-row class="sticky-top bg-light mx-0 py-2" align-h="center">
          <b-col sm="12" md="4">
            <b-button block variant="info" @click="doSave">
              <i class="fa fa-print" aria-hidden="true"></i> Lưu Cấu hình
            </b-button>
          </b-col>
        </b-row>

        <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
          <form role="form" @submit.prevent="handleSubmit(doSave)">
            <b-card class="mb-3 m-2" no-body>
              <b-card-header
                header-tag="header"
                class="p-1 d-flex justify-content-between align-items-center"
              >
                <b-button variant="link" href="#" v-b-toggle="'email'">
                  <span>Cấu hình email</span>
                </b-button>
              </b-card-header>
              <b-collapse visible id="email">
                <b-card-body class="px-2">
                  <b-row>
                    <b-col md="12">
                      <ValidationProvider
                        name="SMTP Host"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          v-model="configs['EMAIL_HOST'].value"
                          placeholder="Ex: smtp.gmail.com"
                          label="SMTP Host"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      <ValidationProvider
                        name="Mã hóa"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="Ex: tls"
                          label="Kiểu mã hóa"
                          v-model="configs['EMAIL_ENCRYTION'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                      <ValidationProvider
                        name="SMTP Port"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="Ex: 587"
                          label="SMTP Port"
                          type="number"
                          v-model="configs['EMAIL_PORT'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      <ValidationProvider
                        name="SMTP Username"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="SMTP Username"
                          label="SMTP Username"
                          v-model="configs['EMAIL_USERNAME'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                      <ValidationProvider
                        name="SMTP Password"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="SMTP Password"
                          label="SMTP Password"
                          v-model="configs['EMAIL_PASSWORD'].value"
                          type="password"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-button variant="success" v-b-modal.testSendEmail
                    >Test Send Email</b-button
                  >
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card class="mb-3 m-2" no-body>
              <b-card-header
                header-tag="header"
                class="p-1 d-flex justify-content-between align-items-center"
              >
                <b-button variant="link" href="#" v-b-toggle="'system'">
                  <span>Cấu hình hệ thống</span>
                </b-button>
              </b-card-header>
              <b-collapse visible id="system">
                <b-card-body class="px-2">
                  <b-row>
                    <b-col md="12">
                      <ValidationProvider
                        name="Tên công ty"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          v-model="configs['COMPANY_NAME'].value"
                          placeholder="Ex: CTY TNHH ABC"
                          label="Tên công ty"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      <ValidationProvider
                        name="Số điện thoại"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="Ex: 0945123123"
                          label="Số điện thoại"
                          v-model="configs['COMPANY_PHONE'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                      <ValidationProvider
                        name="Email"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="Ex: company@domain.com"
                          label="Email"
                          v-model="configs['COMPANY_EMAIL'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <ValidationProvider
                        name="Địa chỉ"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <base-input
                          placeholder="Địa chỉ"
                          label="Địa chỉ"
                          v-model="configs['COMPANY_ADDRESS'].value"
                          :error="errors[0]"
                          :valid="errors.length == 0"
                        >
                        </base-input>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </form>
        </ValidationObserver>

        <b-modal
          id="testSendEmail"
          title="Test Send Email"
          @ok="handleSendTestEmail"
        >
          <block :nocard="true" :nobody="true" ref="bTestEmail">
            <ValidationObserver ref="frmTestEmail" v-slot="{ handleSubmit }">
              <form
                role="form"
                @submit.prevent="handleSubmit(handleSendTestEmail)"
              >
                <ValidationProvider
                  name="Địa chỉ nhận"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <base-input
                    v-model="emailTest"
                    label="Địa chỉ email nhận"
                    placeholder="Ex : example@domain.com"
                    :error="errors[0]"
                    :valid="errors.length == 0"
                  >
                  </base-input>
                </ValidationProvider>
              </form>
            </ValidationObserver>
          </block>
        </b-modal>
      </block>
    </div>
  </div>
</template>
<script>
import { configService } from "@/_services";
export default {
  name: "config",
  props: {},
  data() {
    return {
      configs: {
        EMAIL_HOST: {
          key: "EMAIL_HOST",
          value: "",
          description: ""
        },
        EMAIL_ENCRYTION: {
          key: "EMAIL_ENCRYTION",
          value: "",
          description: ""
        },
        EMAIL_PORT: {
          key: "EMAIL_PORT",
          value: "",
          description: ""
        },
        EMAIL_USERNAME: {
          key: "EMAIL_USERNAME",
          value: "",
          description: ""
        },
        EMAIL_PASSWORD: {
          key: "EMAIL_PASSWORD",
          value: "",
          description: ""
        },
        COMPANY_NAME: {
          key: "COMPANY_NAME",
          value: "",
          description: ""
        },
        COMPANY_PHONE: {
          key: "COMPANY_PHONE",
          value: "",
          description: ""
        },
        COMPANY_EMAIL: {
          key: "COMPANY_EMAIL",
          value: "",
          description: ""
        },
        COMPANY_ADDRESS: {
          key: "COMPANY_ADDRESS",
          value: "",
          description: ""
        }
      },
      emailTest: ""
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$refs.bconfig.block();
      configService
        .findAll()
        .then(res => {
          let configs = res.data;
          configs.forEach(element => {
            if (this.configs[element.key]) {
              this.configs[element.key].id = element.id;
              this.configs[element.key].key = element.key;
              this.configs[element.key].value = element.value;
              this.configs[element.key].description = element.description;
            } else {
              this.configs[element.key] = element;
            }
          });
        })
        .finally(() => {
          this.$refs.bconfig.unBlock();
        });
    },
    doSave() {
      var self = this;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bconfig.block();
        let configsTmp = Object.assign({}, self.configs);
        let configs = Object.values(configsTmp);
        configService
          .saveConfig(configs)
          .then(res => {
            let configs = res.data;
            configs.forEach(element => {
              self.configs[element.key].id = element.id;
              self.configs[element.key].key = element.key;
              self.configs[element.key].value = element.value;
              self.configs[element.key].description = element.description;
            });
            self.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bconfig.unBlock();
          });
      });
    },
    handleSendTestEmail(bvModalEvt) {
      bvModalEvt.preventDefault();
      var self = this;
      this.$refs.frmTestEmail.validate().then(success => {
        if (!success) return;
        this.$refs.bTestEmail.block();
        configService
          .testEmail(self.emailTest)
          .then(res => {
            self.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bTestEmail.unBlock();
          });
      });
    }
  }
};
</script>
